<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Edit Credit" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="edit()" ngNativeValidate>
          <app-credit-form [credit]="credit" *ngIf="credit"></app-credit-form>
        </form>
      </div>
    </section>
  </div>
</div>
